import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { QueryFilterService } from "../../core/services/query-filter-service";
import { Observable } from "rxjs";
import { globals } from "../../globals";
import { IGridifyQuery } from "gridify-client";
import { TipoSituacaoCadastral } from "../../dominio/enums";
import { PaginatedModel } from "../../dominio/paginated-model";
import { GiLojaModel } from "../../dominio/gi-loja-model";
import { MenuModel } from "../models/menu-model";
import { FiltroModel } from "../models/filtro-model";
import { Produto } from "src/app/models/produto";
import { BreadCrumbModel } from "../models/bread-crumb-model";
import { ItemPedido } from "src/app/models/pedido";



export class MenuGetManyResponse {
  results: MenuModel[];
  pagination: PaginatedModel;
}

export class FiltroGetManyResponse {
  results: FiltroModel[];
  pagination: PaginatedModel;
}

export class ProdutoGetManyResponse {
  results: Produto[];
  pagination: PaginatedModel;
}

export class ProdutoGetManyPorReferenciaResponse {
  results: ItemPedido[];
  pagination: PaginatedModel;
}

export class BreadCrumbGetManyResponse {
  results: BreadCrumbModel[];
  pagination: PaginatedModel;
}

@Injectable({
  providedIn: 'root'
})
export class LojaService {
  constructor(
    private http: HttpClient,
    private queryFilterService: QueryFilterService
  ) {
  }

  buscarMenus(idLoja: number, queryFilter: IGridifyQuery | null = null): Observable<MenuGetManyResponse>{
    const params = this.queryFilterService.getQueryParams(queryFilter);

    return this.http.get<MenuGetManyResponse>(`${globals.apiUrl}/api/v2/lojas/${idLoja}/menus`, { params });
  }

  buscarFiltros(idLoja: number, idMenu: number, idCd: number | null = null, aplicarFiltro,  filtros: any[] | null = null, queryFilter: IGridifyQuery | null = null): Observable<FiltroGetManyResponse>{
    let params = this.queryFilterService.getQueryParams(queryFilter);

    if (filtros) {
      filtros.forEach(p => {
        params = params.append('filtro', p);
      });
    }

    if (idCd !== null && idCd !== undefined) {
      params = params.append('idCd', idCd.toString());
    }

    if (aplicarFiltro !== null && aplicarFiltro !== undefined) {
      params = params.append('aplicarFiltro', aplicarFiltro);
    }

    return this.http.get<FiltroGetManyResponse>(`${globals.apiUrl}/api/v2/lojas/${idLoja}/menus/${idMenu}/filtros`, { params });
  }

  buscarProdutos(idLoja: number, idMenu: number | null = null, idCd: number | null = null, filtros: any[] | null = null, queryFilter: IGridifyQuery | null = null): Observable<ProdutoGetManyResponse>{
    let params = this.queryFilterService.getQueryParams(queryFilter);

    if (filtros) {
      filtros.forEach(p => {
        params = params.append('filtro', p);
      });
    }

    if (idMenu !== null && idMenu !== undefined) {
      params = params.append('idMenu', idMenu.toString());
    }

    if (idCd !== null && idCd !== undefined) {
      params = params.append('idCd', idCd.toString());
    }

    return this.http.get<ProdutoGetManyResponse>(`${globals.apiUrl}/api/v2/lojas/${idLoja}/produtos`, { params });
  }

  buscarProdutosPorReferencia(idLoja: number, idCd: number | null = null, dados: any): Observable<ProdutoGetManyPorReferenciaResponse>{
    let params = new HttpParams();

    if (idCd !== null && idCd !== undefined) {
      params = params.append('idCd', idCd.toString());
    }

    return this.http.post<ProdutoGetManyPorReferenciaResponse>(`${globals.apiUrl}/api/v2/lojas/${idLoja}/produtosPorReferencia`, dados, { params });
  }

  buscarBreadCrumbs(idLoja: number, idMenu: number | null = null): Observable<BreadCrumbGetManyResponse>{
    let params = new HttpParams();

    if (idMenu !== null && idMenu !== undefined) {
      params = params.append('idMenu', idMenu.toString());
    }

    return this.http.get<BreadCrumbGetManyResponse>(`${globals.apiUrl}/api/v2/lojas/${idLoja}/breadcrumbs`, { params });
  }

  baixarModelo(idLoja: number) {
    return this.http.get(`${globals.apiUrl}/api/v2/lojas/${idLoja}/produtos/modeloimportacao`, { responseType: 'blob' });
  }
}
